import { useQuery } from '@tanstack/react-query';
import { queryKey } from '../../../../../constant/queryKey';
import { mumulLiveService } from 'shared/src/api';
import { useIsMumulLiveExposed } from '../hooks/useIsMumulLiveExposed';

/**
 * 무물라이브 현재 캠페인 조회.
 * 무물라이브 노출 대상(EXP1788 B군) + LIVE(`isOnair`) + `profileSno` 가 있을 때만 호출한다.
 * (LIVE 노출 시 campaign_sno 를 얻기 위해 사용)
 */
export const useMumulLiveCurrentCampaign = (
  profileSno: number | null,
  isOnair: boolean,
) => {
  const isExposed = useIsMumulLiveExposed();

  return useQuery({
    queryKey: queryKey.mumulLiveCurrentCampaign(profileSno ?? 0),
    queryFn: () =>
      mumulLiveService.getMumulLiveCurrentCampaign(profileSno as number),
    enabled: isExposed && isOnair && profileSno != null,
  });
};
